module.exports = __webpack_public_path__ + "static/media/white-snake-small.96113275.png";